import { Stack } from "@chakra-ui/react";
import { NavLink } from "./NavLink";
import { NavSection } from "./NavSection";

import { IoMdBusiness, IoIosPaper } from "react-icons/io";
import {
  RiDashboardLine,
  RiFileCopy2Fill,
  RiFileChartLine,
} from "react-icons/ri";
import { FaUser } from "react-icons/fa";
import {
  MdWork,
  MdDescription,
  MdRecordVoiceOver,
  MdAccountCircle,
  MdAttachMoney,
  MdWrapText,
} from "react-icons/md";
import { AiOutlineMail, AiFillHome, AiOutlineBarChart } from "react-icons/ai";
import { useAuth } from "hooks/useAuth";
import Diviser from "Components/Diviser";
import { useState, useEffect } from "react";

export function SidebarNav() {
  const [tipo, setTipo] = useState();
  const {
    user,
    qtdContratosCobranca,
    qtdContratosRepasseTaxas,
    qtdContratosUtilizacao,
    qtdContratosCoparticipacao,
  } = useAuth();

  useEffect(() => {
    setTipo(user?.entidade?.tipos_entidade);
    console.log(user?.entidade?.tipos_entidade);
  }, [user]);

  return (
    <Stack align="flex-start" paddingInline="7">
      <NavSection>
        <NavLink href="/" icon={AiFillHome}>
          Home
        </NavLink>
        {user?.role.name === "Admin" && (
          <>
            <Diviser titulo="InterBrasil" />
            <NavLink href="/interbrasil/perfil" icon={MdAccountCircle}>
              Perfil
            </NavLink>
            <NavLink href="/interbrasil/contatos" icon={AiOutlineMail}>
              Contatos cadastrados
            </NavLink>

            <Diviser titulo="Cadastros" />

            <NavLink href="/interbrasil/operadoras" icon={RiDashboardLine}>
              Operadoras
            </NavLink>
            <NavLink href="/interbrasil/pessoas-juridicas" icon={IoMdBusiness}>
              Pessoas Jurídicas
            </NavLink>
            <NavLink href="/interbrasil/contratos" icon={IoIosPaper}>
              Contratos
            </NavLink>
            <NavLink href="/interbrasil/usuarios" icon={FaUser}>
              Usuários
            </NavLink>
            <NavLink href="/interbrasil/servicos" icon={MdWork}>
              Atalhos
            </NavLink>

            <Diviser titulo="Operadora" />

            <NavLink
              href="/interbrasil/operadoras/coparticipacao"
              icon={RiFileCopy2Fill}
            >
              Coparticipação
            </NavLink>

            <NavLink
              href="/interbrasil/operadoras/utilizacao"
              icon={RiFileChartLine}
            >
              Utilização
            </NavLink>
            <NavLink
              href="/interbrasil/operadoras/painel-de-controle"
              icon={AiOutlineBarChart}
            >
              Painel de Controle
            </NavLink>

            <Diviser titulo="Pessoa Jurídica" />
            <NavLink
              href="/interbrasil/pessoas-juridicas/cobranca"
              icon={MdAttachMoney}
            >
              Cobrança
            </NavLink>
            <NavLink
              href="/interbrasil/pessoas-juridicas/repasse-taxas"
              icon={MdWrapText}
            >
              Repasse de Taxas
            </NavLink>
            <NavLink
              href="/interbrasil/pessoas-juridicas/painel-de-controle"
              icon={AiOutlineBarChart}
            >
              Painel de Controle
            </NavLink>
          </>
        )}
        {user && (user.operadora || user.entidade) && (
          <>
            {user?.entidade && tipo && (
              <Diviser
                titulo={
                  tipo === 1
                    ? "Empresa"
                    : tipo === 2
                    ? "Conselho"
                    : tipo === 3
                    ? "Sindicato"
                    : tipo === 4 && "Associação"
                }
              />
            )}
            {user.operadora && <Diviser titulo="Operadora" />}
            <NavLink href="/portal/perfil" icon={MdAccountCircle}>
              Perfil
            </NavLink>
            {!user.fl_primeiro_acesso && (
              <>
                <NavLink href="/portal/contatos" icon={AiOutlineMail}>
                  Cadastrar contatos
                </NavLink>
                {user.operadora && (
                  <>
                    {/* {(qtdContratosUtilizacao > 0 ||
                      qtdContratosCoparticipacao > 0) && <Diviser titulo="-" />} */}
                    {qtdContratosCoparticipacao > 0 && (
                      <>
                        <NavLink
                          href="/portal/operadoras/coparticipacao"
                          icon={RiFileCopy2Fill}
                        >
                          Coparticipação
                        </NavLink>
                      </>
                    )}
                    {qtdContratosUtilizacao > 0 && (
                      <>
                        <NavLink
                          href="/portal/operadoras/utilizacao"
                          icon={RiFileChartLine}
                        >
                          Utilização
                        </NavLink>
                      </>
                    )}
                    {(qtdContratosUtilizacao > 0 ||
                      qtdContratosCoparticipacao > 0) && (
                      <NavLink
                        href="/portal/operadoras/painel-de-controle"
                        icon={AiOutlineBarChart}
                      >
                        Painel de Controle
                      </NavLink>
                    )}
                  </>
                )}

                {user.entidade && (
                  <>
                    {(qtdContratosCobranca > 0 ||
                      qtdContratosRepasseTaxas > 0) && (
                      <Diviser titulo="Financeiro" />
                    )}
                    {qtdContratosCobranca > 0 && (
                      <>
                        <NavLink
                          href="/portal/pessoas-juridicas/cobranca"
                          icon={MdAttachMoney}
                        >
                          Cobrança
                        </NavLink>
                      </>
                    )}
                    {qtdContratosRepasseTaxas > 0 && (
                      <>
                        <NavLink
                          href="/portal/pessoas-juridicas/repasse-taxas"
                          icon={MdWrapText}
                        >
                          Repasse de Taxas
                        </NavLink>
                      </>
                    )}
                    {(qtdContratosCobranca > 0 ||
                      qtdContratosRepasseTaxas > 0) && (
                      <NavLink
                        href="/portal/pessoas-juridicas/painel-de-controle"
                        icon={AiOutlineBarChart}
                      >
                        Painel de Controle
                      </NavLink>
                    )}
                  </>
                )}
                <Diviser titulo="InterBrasil" />
                <NavLink href="/portal/servicos" icon={MdWork}>
                  Atalhos
                </NavLink>
                <NavLink href="/portal/documentos" icon={MdDescription}>
                  Documentos
                </NavLink>
                <NavLink href="/portal/suporte" icon={MdRecordVoiceOver}>
                  Suporte
                </NavLink>
              </>
            )}
          </>
        )}
      </NavSection>
    </Stack>
  );
}
